// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","532":"styles","691":"component---src-pages-index-tsx","774":"framework"}[chunkId] + "-" + {"218":"b67f128bd18c9168a7ff","532":"61c8b655b79281b0d34f","691":"917b6c5307c419cbbcfe","774":"c7a69b1976ceee611f0c"}[chunkId] + ".js";
};